import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * @deprecated use /v2/payments/period-structure instead
 */
const getPeriodStructure = (queryParams: RequestDto): IRequest => ({
    uri: '/v1/payments/period-structure',
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams,
});

export type { RequestDto };

export default getPeriodStructure;
